import { useContext } from 'react'
import {
  StaticContentfulContext,
  IStaticContentfulContext,
} from '../../providers/StaticContentfulProvider'

export default function useStaticContentful(): IStaticContentfulContext {
  return useContext(StaticContentfulContext)
}
